"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationsList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("./shared/styles");

var _excluded = ["inverse", "integrations", "overflowLabel"],
    _excluded2 = ["name", "image"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ehtkj8m2"
} : {
  target: "ehtkj8m2",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1og3vwv",
  styles: "display:flex;align-items:center;gap:10px"
} : {
  name: "1og3vwv",
  styles: "display:flex;align-items:center;gap:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Integration = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Button, process.env.NODE_ENV === "production" ? {
  target: "ehtkj8m1"
} : {
  target: "ehtkj8m1",
  label: "Integration"
})("border-radius:", _styles.spacing.borderRadius.small, "px;padding:8px;", function (props) {
  return props.inverse && /*#__PURE__*/(0, _theming.css)("box-shadow:rgb(255 255 255 / 10%) 0 0 0 1px inset;&:hover,&:active,&:focus,&:active:focus:hover{box-shadow:", _styles.color.secondary, " 0 0 0 1px inset;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Integration;"));
}, " span{display:block;}img{display:block;width:24px;height:24px;object-fit:contain;}");
Integration.defaultProps = {
  appearance: 'outline',
  isLink: true,
  containsIcon: true
};
var OverflowLabel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ehtkj8m0"
} : {
  target: "ehtkj8m0",
  label: "OverflowLabel"
})(_styles.text.regular, ";color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.5)' : _styles.color.mediumdark;
}, ";");

var IntegrationsList = function IntegrationsList(_ref) {
  var inverse = _ref.inverse,
      integrations = _ref.integrations,
      overflowLabel = _ref.overflowLabel,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, props, integrations.map(function (_ref2) {
    var name = _ref2.name,
        image = _ref2.image,
        integration = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(Integration, (0, _extends2["default"])({
      inverse: inverse,
      key: name
    }, integration), /*#__PURE__*/_react["default"].createElement("img", {
      src: image,
      alt: name
    }));
  }), /*#__PURE__*/_react["default"].createElement(OverflowLabel, {
    inverse: inverse
  }, overflowLabel));
};

exports.IntegrationsList = IntegrationsList;